import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import ImageUploading from "react-images-uploading";
import SelectDropdown from "../../components-react/SelectDropdown";
import Loader from "../../ui/Loader";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import {
  experiences_per_week,
  fitness_experiences,
  gender,
  memberGoals,
  pt_trial_focus,
  type_of_exercise,
} from "../../common-data/DropdowData";
import {
  matchGenderFun,
  matchGoalFun,
  matchOtherGoalFun,
  matchFitnessExperienceFun,
  matchExerciseDurationFun,
  matchExercisesFun,
  matchOtherExerciseFun,
  matchPTTrialFocusFun,
  matchOtherPTTrialFocusFun,
  validateTMEForm,
} from "./validations";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { fetchUserDetailsByMobileData } from "../../../redux/reducers/apiSlice";
import MultiSelect from "../../components-react/MultiSelect";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import {
  trainer_member_engagement_form_submit,
  update_trainer_member_engagement_form_submit,
} from "../../../data/ApiEndpoints";
import SubmissionThankYouPage from "../common/SubmissionThankYouPage";
import { extractFileName } from "../../common-data/Conversions";
import { uploadImage } from "../../../redux/reducers/postApiSlice";
import { formatTimezoneThenStraight } from "../../common-data/Converts";

const TMEForm = ({ userInfoData, isEdit, rowData, callFunction }) => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const { postPutLoading } = useSelector((state) => state.common);
  const { loading, userDetailsByMobile } = useSelector((state) => state.api);

  const [isFetchUser, setIsFetchUser] = useState(false);
  const [memberFetchedData, setMemberFetchedData] = useState(null);
  const [firstEngagementData, setFirstEngagementData] = useState(null);

  const {
    user_name,
    user_mobile,
    user_email,
    gender: rowDataGender,
    exercise_freq,
    fitness_goal,
    consultation_focus_on,
    exercise_type,
    fitness_experience,
    worked_with_pt_trainer,
    free_pt_consultation,
    pt_schedule_date,
    pt_experience,
    medical_history,
    physical_limitation,
    no_pt_consult_reason,
    description,
    user_id,
    uid,
    bca_report,
    prog_pics,
    trainer_name,
    date_added,
  } = isEdit ? rowData : firstEngagementData ? firstEngagementData : {};

  const isGenderMatched = rowDataGender ? matchGenderFun(rowDataGender) : "";

  const isGoalMatched = fitness_goal ? matchGoalFun(fitness_goal) : "";

  const isOtherGoalMatched = fitness_goal
    ? matchOtherGoalFun(fitness_goal)
    : "";

  const isFitnessExpMatched = fitness_experience
    ? matchFitnessExperienceFun(fitness_experience)
    : "";

  const isExerciseDurationMatched = exercise_freq
    ? matchExerciseDurationFun(exercise_freq)
    : "";

  const isExercisesMatched = exercise_type
    ? matchExercisesFun(exercise_type)
    : "";

  const isOtherExercisesMatched = exercise_type
    ? matchOtherExerciseFun(exercise_type)
    : "";

  const isPTFocusesMatched = consultation_focus_on
    ? matchPTTrialFocusFun(consultation_focus_on)
    : "";

  const isOtherPTFocusesMatched = consultation_focus_on
    ? matchOtherPTTrialFocusFun(consultation_focus_on)
    : "";

  const iniFormValues = {
    trainerName: userInfoData?.name || "",
    trainerMobile: userInfoData?.mobile || "",
    trainerEmail: userInfoData?.email || "",
    selectedGym:
      userInfoData?.gym_name && userInfoData?.gym_id
        ? {
            label: userInfoData?.gym_name,
            value: userInfoData?.gym_id,
          }
        : "",
    memberName: user_name ? user_name : "",
    memberMobile: user_mobile || "",
    memberEmail: user_email || "",
    selectedGender: isGenderMatched || "",
    selectedUserGoals: isGoalMatched || [],
    otherMemberFitnessGoal: isOtherGoalMatched || "",
    selectedFitnessExp: isFitnessExpMatched || "",
    selectedExerciseDuration: isExerciseDurationMatched || "",
    userMedicalHistory: medical_history || "",
    memberPhysicalLimitations: physical_limitation || "",
    selectedTypeOfExercise: isExercisesMatched || [],
    otherTypeOfExercise: isOtherExercisesMatched || "",
    isInterestedForPT: free_pt_consultation ? true : false,
    isWorkedWithPTBefore: worked_with_pt_trainer ? true : false,
    ptTrailDate: pt_schedule_date || "",
    selectedSlot: "",
    selectedPTTrialFocus: isPTFocusesMatched || [],
    otherPTTrialFocus: isOtherPTFocusesMatched || "",
    previousPTExperience: pt_experience || "",
    notPtReason: no_pt_consult_reason || "",
    remarks: description || "",
    bcaFile: "",
    bcaFileUrl: bca_report || "",
    transformationImageFileUrl: prog_pics || [],
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const imgVdoInitials = {
    transformationImageFile:
      prog_pics?.length > 0 ? prog_pics.map((img) => ({ data_url: img })) : [],
  };
  const [formImages, setFormImages] = useState(imgVdoInitials);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const iniMemStatus = {
    isShowForm: false,
    errorMessage: "",
  };
  const [memberStatus, setMemberStatus] = useState(iniMemStatus);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "memberMobile") {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: value,
      }));
      setIsSubmit(false);
      setIsFetchUser(false);
      setMemberFetchedData(null);
      setMemberStatus(iniMemStatus);
    } else if (name === "bcaFile") {
      setFormValues((prev) => ({
        ...prev,
        [name]: file,
      }));
      handleUploadImage(file, "bcaFileUrl");
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onChangeImages = (imageList, name) => {
    setIsSubmit(false);

    setFormImages((prevImages) => {
      const uniqueImages = [
        ...new Set([...(prevImages[name] || []), ...imageList]),
      ].slice(0, 3);

      return {
        ...prevImages,
        [name]: uniqueImages,
      };
    });

    const previousImages = formImages[name] || [];
    const newImages = imageList.filter(
      (newImage) =>
        !previousImages.some(
          (prevImage) => prevImage.data_url === newImage.data_url
        )
    );

    if (newImages.length > 0) {
      newImages.forEach(async (image) => {
        const blob = await fetch(image?.data_url).then((res) => res.blob());
        const file = new File([blob], "filename.jpeg", { type: "image/jpeg" });

        handleUploadImage(file, name);
      });
    }
  };

  const handleImageRemove = (index) => {
    setFormImages((prevImages) => {
      const updatedImages = [...prevImages.transformationImageFile];
      updatedImages.splice(index, 1);
      return {
        ...prevImages,
        transformationImageFile: updatedImages,
      };
    });

    setFormValues((prevValues) => {
      const updatedUrls = [...(prevValues.transformationImageFileUrl || [])];
      updatedUrls.splice(index, 1);
      return {
        ...prevValues,
        transformationImageFileUrl: updatedUrls,
      };
    });
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateTMEForm(formValues, isEdit || firstEngagementData));
    setIsSubmit(true);
  };

  function getMemberDetails() {
    dispatch(
      fetchUserDetailsByMobileData({
        userMobile: formValues.memberMobile,
        token: userInfoData?.token,
        qps: "engagement_data=1",
      })
    );
  }

  function onClickFetchUserDetails(e) {
    e.preventDefault();

    if (formValues.memberMobile && !formErrors.memberMobile) {
      setIsFetchUser(true);
      getMemberDetails();
    }
  }

  function onClearNumber(e) {
    e && e.preventDefault();

    const handleConfirm = () => {
      setFormValues((prevs) => ({
        ...prevs,
        selectedGym: prevs.selectedGym,
      }));
      setFormImages(imgVdoInitials);
      setIsSubmit(false);
      setIsFetchUser(false);
      setMemberFetchedData(null);
      setFirstEngagementData(null);
    };

    showConfirmAlert(handleConfirm, `You want to clear the form?`);
  }

  const handleSubmitForm = async (payload) => {
    const method = isEdit ? "PUT" : "POST";
    const endpoint = isEdit
      ? update_trainer_member_engagement_form_submit
      : trainer_member_engagement_form_submit;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);
        setFormImages(imgVdoInitials);
        setIsFetchUser(false);
        setMemberFetchedData(null);
        setIsFormSubmitted(true);
        setMemberFetchedData(null);
        setFirstEngagementData(null);
        isEdit && callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleUploadImage = async (file, fileName) => {
    setIsSubmit(false);

    try {
      const actionResult = dispatch(
        uploadImage({ file, TOKEN: userInfoData?.token })
      );
      const result = await actionResult;

      if (result?.payload?.status) {
        setFormValues((prev) => {
          if (fileName === "transformationImageFile") {
            const updatedUrls = [
              ...(prev.transformationImageFileUrl || []),
              result.payload.image_url,
            ].slice(0, 3);

            return {
              ...prev,
              transformationImageFileUrl: updatedUrls,
            };
          } else {
            return {
              ...prev,
              [fileName]: result?.payload?.image_url || "",
            };
          }
        });
        // toast.success("Image Upload Success!");
      } else {
        // const errorMessage = result?.error?.message || result?.payload?.message;
        // toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("handleUploadImage ERROR => ", error);
    }
  };

  useEffect(() => {
    setFormValues((prevs) => ({
      ...prevs,
      trainerName: userInfoData?.name || "",
      trainerMobile: userInfoData?.mobile || "",
      trainerEmail: userInfoData?.email || "",
      selectedGym:
        userInfoData?.gym_name && userInfoData?.gym_id
          ? {
              label: userInfoData?.gym_name,
              value: userInfoData?.gym_id,
            }
          : "",
    }));
  }, []);

  useEffect(() => {
    if (isEdit || firstEngagementData) {
      setFormValues((prevs) => ({
        ...prevs,
        memberName: user_name ? user_name : "",
        memberMobile: user_mobile || "",
        memberEmail: user_email || "",
        selectedGender: isGenderMatched || "",
        selectedUserGoals: isGoalMatched || [],
        otherMemberFitnessGoal: isOtherGoalMatched || "",
        selectedFitnessExp: isFitnessExpMatched || "",
        selectedExerciseDuration: isExerciseDurationMatched || "",
        userMedicalHistory: medical_history || "",
        memberPhysicalLimitations: physical_limitation || "",
        selectedTypeOfExercise: isExercisesMatched || [],
        otherTypeOfExercise: isOtherExercisesMatched || "",
        isInterestedForPT: free_pt_consultation ? true : false,
        isWorkedWithPTBefore: worked_with_pt_trainer ? true : false,
        ptTrailDate: pt_schedule_date || "",
        selectedPTTrialFocus: isPTFocusesMatched || [],
        otherPTTrialFocus: isOtherPTFocusesMatched || "",
        previousPTExperience: pt_experience || "",
        notPtReason: no_pt_consult_reason || "",
        remarks: description || "",
        bcaFileUrl: bca_report || "",
        transformationImageFileUrl: prog_pics || [],
      }));

      setFormImages((prevs) => ({
        ...prevs,
        transformationImageFile:
          prog_pics?.length > 0
            ? prog_pics.map((img) => ({ data_url: img }))
            : [],
      }));
    } else {
      setFormValues(iniFormValues);
      setFormImages(imgVdoInitials);
    }
  }, [isEdit, firstEngagementData]);

  useEffect(() => {
    setFormErrors(validateTMEForm(formValues));
  }, [formValues]);

  useEffect(() => {
    // if (userInfoData?.gym_name && userInfoData?.gym_id) {
    dispatch(fetchGymData(userInfoData?.token));
    // }
  }, []);

  useEffect(() => {
    if (
      isFetchUser &&
      !loading &&
      !formErrors.memberMobile &&
      userDetailsByMobile?.status &&
      userDetailsByMobile?.data?.length > 0
    ) {
      const memberData = userDetailsByMobile.data[0];
      setMemberFetchedData(memberData);
    } else if (
      isFetchUser &&
      !loading &&
      !formErrors.memberMobile &&
      !userDetailsByMobile?.status
    ) {
      userDetailsByMobile?.message && toast.error(userDetailsByMobile?.message);
      setMemberFetchedData(null);
      setIsFetchUser(false);
      return;
    } else {
      setMemberFetchedData(null);
      return;
    }

    if (
      userDetailsByMobile?.status &&
      userDetailsByMobile?.engagement_data?.length > 0
    ) {
      const firstEngagement = userDetailsByMobile.engagement_data[0];
      setFirstEngagementData(firstEngagement);
    } else {
      setFirstEngagementData(null);
    }
  }, [isFetchUser, loading, userDetailsByMobile, formErrors.memberMobile]);

  useEffect(() => {
    if (memberFetchedData) {
      setFormValues((prevs) => ({
        ...prevs,
        memberName: memberFetchedData?.name || "",
        memberEmail: memberFetchedData?.email || "",
        selectedGender: memberFetchedData?.name || "",
      }));
    }
  }, [memberFetchedData]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const selectedUserGoalsValues = formValues.selectedUserGoals
        ?.filter((goal) => goal.value !== "other" && goal.value !== "false")
        ?.map((goal) => goal.value);
      if (formValues.otherMemberFitnessGoal) {
        selectedUserGoalsValues.push(formValues.otherMemberFitnessGoal);
      }
      const selectedUserGoalsString = selectedUserGoalsValues?.join(", ");
      // ------------

      const selectedMemberExerciseTypesValues =
        formValues.selectedTypeOfExercise
          ?.filter((goal) => goal.value !== "other" && goal.value !== "false")
          ?.map((goal) => goal.value);
      if (formValues.otherTypeOfExercise) {
        selectedMemberExerciseTypesValues.push(formValues.otherTypeOfExercise);
      }
      const selectedMemberExerciseTypesValuesString =
        selectedMemberExerciseTypesValues?.join(", ");
      // ------------

      const selectedPTTrialFOcusValues = formValues.selectedPTTrialFocus
        ?.filter((goal) => goal.value !== "other" && goal.value !== "false")
        ?.map((goal) => goal.value);
      if (formValues.otherPTTrialFocus) {
        selectedPTTrialFOcusValues.push(formValues.otherPTTrialFocus);
      }
      const selectedPTTrialFOcusValuesString =
        selectedPTTrialFOcusValues?.join(", ");
      // ------------

      const userData = {
        pt_schedule_date:
          formValues.isInterestedForPT && formValues.ptTrailDate
            ? formValues.ptTrailDate
            : "",
        gym_id: formValues.selectedGym?.value || userInfoData?.gym_id || "",
        user_id: isEdit && user_id ? user_id : memberFetchedData?.uid || "",
        trainer_id: userInfoData?.uid || userInfoData?.user_id || "",
        fitness_goal: selectedUserGoalsString || "",
        gender: formValues.selectedGender?.value || "",
        fitness_experience: formValues.selectedFitnessExp?.value || "",
        worked_with_pt_trainer: formValues.isWorkedWithPTBefore ? 1 : 0,
        pt_experience: formValues.previousPTExperience || "",
        exercise_freq: formValues.selectedExerciseDuration?.value || "",
        medical_history: formValues.userMedicalHistory || "",
        physical_limitation: formValues.memberPhysicalLimitations || "",
        exercise_type: selectedMemberExerciseTypesValuesString || "",
        free_pt_consultation: formValues.isInterestedForPT ? 1 : 0,
        consultation_focus_on:
          formValues.isInterestedForPT && selectedPTTrialFOcusValuesString
            ? selectedPTTrialFOcusValuesString
            : "",
        no_pt_consult_reason: formValues.notPtReason || "",
        description: formValues.remarks || "",
        bca_report: formValues.bcaFileUrl || "",
        prog_pics: formValues.transformationImageFileUrl || [],
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      if (isEdit || firstEngagementData) {
        userData.uid = uid;
      }

      showConfirmAlert(
        handleConfirm,
        `${
          firstEngagementData
            ? "This member engagement process has already been completed. It will only be mapped after receiving approval from the approval manager."
            : "Are you sure!"
        }`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  useEffect(() => {
    if (memberFetchedData && !loading) {
      const memberName = memberFetchedData?.name || "Member";
      // const memberStatus = memberFetchedData?.status || "";
      const memberStatus = memberFetchedData?.current_subscription_status || "";
      const memberGymId = memberFetchedData?.gym_id || "";
      const memberGymName = memberFetchedData?.gym_name || "";
      const memberAcountType = memberFetchedData?.account_type || "";

      if (memberStatus !== "active") {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `${memberName} Do Not Have Active Subscription`,
        });
      } else if (
        memberStatus === "active" &&
        memberGymId !== userInfoData?.gym_id
      ) {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `${
            memberFetchedData?.name || "Member"
          } Has Active Subscription In Gym ${
            memberFetchedData?.gym_name || ""
          }`,
        });
      } else if (memberGymId !== userInfoData?.gym_id) {
        const handleConfirm = () => {
          if (firstEngagementData) {
            const handleConfirm = async () => {
              setMemberStatus({
                isShowForm: true,
                errorMessage: "",
              });
            };

            showConfirmAlert(
              handleConfirm,
              `${user_name}'s engagement already done by ${trainer_name} on ${
                date_added ? formatTimezoneThenStraight(date_added) : "-"
              }. Do you still want to proceed!`,
              "No, Cancel",
              "Yes, proceed"
            );
          } else {
            setMemberStatus({
              isShowForm: true,
              errorMessage: "",
            });
          }
        };

        showConfirmAlert(
          handleConfirm,
          `${memberName} Is Belongs To ${memberGymName} Gym. Do You Want To Change Gym With ${userInfoData?.gym_name} Gym?`,
          "No, Cancel Submission",
          "Yes, Proceed"
        );
      } else if (memberAcountType !== "member") {
        setMemberStatus({
          isShowForm: false,
          errorMessage: `Enterered ${
            memberName || "Number"
          }'s account type - ${memberAcountType} `,
        });
      } else {
        if (firstEngagementData) {
          const handleConfirm = async () => {
            setMemberStatus({
              isShowForm: true,
              errorMessage: "",
            });
          };

          showConfirmAlert(
            handleConfirm,
            `${user_name}'s engagement already done by ${trainer_name} on ${
              date_added ? formatTimezoneThenStraight(date_added) : "-"
            }. Do you still want to proceed!`,
            "No, Cancel",
            "Yes, proceed"
          );
        } else {
          setMemberStatus({
            isShowForm: true,
            errorMessage: "",
          });
        }
      }
    } else {
      setMemberStatus(iniMemStatus);
    }
  }, [memberFetchedData, loading, firstEngagementData]);

  return (
    <div className="form-container open-form-page-container mod-with-images">
      <div className="page-name-label">
        <h1 className="page-name">trainer and member engagement form</h1>
      </div>

      {isFormSubmitted ? (
        <SubmissionThankYouPage setIsFormSubmitted={setIsFormSubmitted} />
      ) : (
        <form className="formContainer">
          <div className="formInputsGrid fourGridSystem">
            <div className="formInputBox">
              <label htmlFor="trainerName" className={`formInputLabel`}>
                trainer Name <span className="required">*</span>
              </label>

              <input
                type="text"
                placeholder="Enter Trainer Full Name"
                className={`formInput ${
                  formErrors?.trainerName ? "formError" : ""
                }`}
                name="trainerName"
                value={formValues.trainerName}
                onChange={onChangeInput}
                disabled={userInfoData?.name}
              />

              <span className="error-label">
                {formErrors?.trainerName || ""}
              </span>
            </div>

            <div className="formInputBox">
              <label htmlFor="trainerMobile" className={`formInputLabel`}>
                trainer mobile <span className="required">*</span>
              </label>

              <input
                type="number"
                placeholder="Enter Trainer Mobile Number"
                className={`formInput ${
                  formErrors?.trainerMobile ? "formError" : ""
                }`}
                name="trainerMobile"
                value={formValues.trainerMobile}
                onChange={onChangeInput}
                disabled={userInfoData?.mobile}
              />

              <span className="error-label">
                {formErrors?.trainerMobile || ""}
              </span>
            </div>

            <div className="formInputBox">
              <label htmlFor="trainerEmail" className={`formInputLabel`}>
                trainer email <span className="required">*</span>
              </label>

              <input
                type="email"
                placeholder="Enter Trainer Email"
                className={`formInput ${
                  formErrors?.trainerEmail ? "formError" : ""
                }`}
                name="trainerEmail"
                value={formValues.trainerEmail}
                onChange={onChangeInput}
                disabled={userInfoData?.email}
              />

              <span className="error-label">
                {formErrors?.trainerEmail || ""}
              </span>
            </div>

            <div className="formInputBox">
              <label htmlFor="selectedGym" className={`formInputLabel`}>
                gym name <span className="required">*</span>
              </label>

              <div
                className={`commonWrapper ${
                  formErrors.selectedGym ? "formError" : ""
                }`}
                style={{
                  border:
                    userInfoData?.gym_name && userInfoData?.gym_id
                      ? "none"
                      : "1px solid #c2c2c2",
                }}>
                <SelectDropdown
                  options={gymData?.length > 0 ? gymData : []}
                  selectedOption={formValues.selectedGym}
                  setSelectedOption={(selectedValue) =>
                    onChangeDropdown("selectedGym", selectedValue)
                  }
                  name="Gym"
                  // isDisable={formValues.selectedGym?.value}
                  isDisable={userInfoData?.gym_name && userInfoData?.gym_id}
                  // preventKeyboardOpen={true}
                />
              </div>
            </div>
          </div>

          {!isEdit && formValues.selectedGym && (
            <div className="formInputsGrid twoGridSystem input-with-btn">
              <div className="formInputBox">
                <label htmlFor="memberMobile" className={`formInputLabel`}>
                  member mobile <span className="required">*</span>
                </label>

                <input
                  type="number"
                  placeholder="Enter Member Mobile Number"
                  className={`formInput ${
                    formErrors?.memberMobile ? "formError" : ""
                  }`}
                  name="memberMobile"
                  value={formValues.memberMobile}
                  onChange={onChangeInput}
                />

                <span className="error-label">
                  {formErrors?.memberMobile || ""}
                </span>

                {!memberStatus.isShowForm && memberStatus.errorMessage && (
                  <span className="info">
                    {memberStatus.errorMessage || ""}
                  </span>
                )}
              </div>

              <div className="formInputButtons">
                <Button
                  type="button"
                  className="saveBtn"
                  variant="danger"
                  onClick={onClickFetchUserDetails}
                  disabled={memberFetchedData || formErrors.memberMobile}>
                  {loading ? <Loader /> : "Fetch Member Details"}
                </Button>
                {!loading && (
                  <Button
                    type="button"
                    className="cancelBtn"
                    variant="dark"
                    onClick={onClearNumber}>
                    Clear
                  </Button>
                )}
              </div>
            </div>
          )}

          {(memberStatus.isShowForm || isEdit) && (
            <>
              <div className="formInputsGrid fourGridSystem">
                <div className="formInputBox">
                  <label htmlFor="memberName" className={`formInputLabel`}>
                    member Name <span className="required">*</span>
                  </label>

                  <input
                    type="text"
                    placeholder="Enter Member Full Name"
                    className={`formInput ${
                      formErrors?.memberName ? "formError" : ""
                    }`}
                    name="memberName"
                    value={formValues.memberName}
                    onChange={onChangeInput}
                    disabled={isEdit && user_name}
                  />

                  <span className="error-label">
                    {formErrors?.memberName || ""}
                  </span>
                </div>

                {isEdit && (
                  <div className="formInputBox">
                    <label htmlFor="memberMobile" className={`formInputLabel`}>
                      member mobile
                    </label>

                    <input
                      type="email"
                      placeholder="Enter Member Mobile"
                      className={`formInput ${
                        formErrors?.memberMobile ? "formError" : ""
                      }`}
                      name="memberMobile"
                      value={formValues.memberMobile}
                      onChange={onChangeInput}
                      disabled={isEdit && user_mobile}
                    />

                    <span className="error-label">
                      {formErrors?.memberMobile || ""}
                    </span>
                  </div>
                )}

                <div className="formInputBox">
                  <label htmlFor="memberEmail" className={`formInputLabel`}>
                    member email{" "}
                    <span className="not required">(Optional)</span>
                  </label>

                  <input
                    type="email"
                    placeholder="Enter Member Email"
                    className={`formInput ${
                      formErrors?.memberEmail ? "formError" : ""
                    }`}
                    name="memberEmail"
                    value={formValues.memberEmail}
                    onChange={onChangeInput}
                    disabled={isEdit && user_email}
                  />

                  <span className="error-label">
                    {formErrors?.memberEmail || ""}
                  </span>
                </div>

                <div className="formInputBox">
                  <label htmlFor="selectedGender" className={`formInputLabel`}>
                    member gender <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedGender ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={gender.slice(0, -1)}
                      selectedOption={formValues.selectedGender}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedGender", selectedValue)
                      }
                      name="Gender"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedGender || ""}
                  </span>
                </div>

                <div className="formInputBox">
                  <label htmlFor="selectedUserGoals" className="formInputLabel">
                    Fitness Goal <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper no-border ${
                      formErrors.selectedUserGoals ? "formError" : ""
                    }`}>
                    <MultiSelect
                      options={memberGoals}
                      state={formValues.selectedUserGoals}
                      setState={(selectedValue) =>
                        setFormValues((prevs) => ({
                          ...prevs,
                          selectedUserGoals: selectedValue,
                        }))
                      }
                      name="Fitness Goal"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedUserGoals || ""}
                  </span>
                </div>

                {formValues.selectedUserGoals?.length > 0 &&
                  formValues.selectedUserGoals?.some(
                    (goal) => goal.value === "other"
                  ) && (
                    <div className="formInputBox twoInputs">
                      <label
                        htmlFor="otherMemberFitnessGoal"
                        className="formInputLabel">
                        Fitness Goal (Other) <span className="required">*</span>
                      </label>

                      <input
                        type="text"
                        className={`formInput ${
                          formErrors?.otherMemberFitnessGoal ? "formError" : ""
                        }`}
                        name="otherMemberFitnessGoal"
                        placeholder="Enter Member Fitness Goal"
                        value={formValues.otherMemberFitnessGoal}
                        onChange={onChangeInput}
                      />

                      <span className="error-label">
                        {formErrors?.otherMemberFitnessGoal || ""}
                      </span>
                    </div>
                  )}

                <div className="formInputBox">
                  <label
                    htmlFor="selectedFitnessExp"
                    className={`formInputLabel`}>
                    Fitness Experience <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedFitnessExp ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={fitness_experiences}
                      selectedOption={formValues.selectedFitnessExp}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown("selectedFitnessExp", selectedValue)
                      }
                      name="Fitness Experience"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedFitnessExp || ""}
                  </span>
                </div>

                <div className="formInputBox">
                  <label
                    htmlFor="selectedExerciseDuration"
                    className={`formInputLabel`}>
                    exercise duration per week{" "}
                    <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper ${
                      formErrors.selectedExerciseDuration ? "formError" : ""
                    }`}>
                    <SelectDropdown
                      options={experiences_per_week}
                      selectedOption={formValues.selectedExerciseDuration}
                      setSelectedOption={(selectedValue) =>
                        onChangeDropdown(
                          "selectedExerciseDuration",
                          selectedValue
                        )
                      }
                      name="Exercise Per Week"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedExerciseDuration || ""}
                  </span>
                </div>

                <div className="formInputBox">
                  <label
                    htmlFor="selectedTypeOfExercise"
                    className="formInputLabel">
                    current exercises <span className="required">*</span>
                  </label>

                  <div
                    className={`commonWrapper no-border ${
                      formErrors.selectedTypeOfExercise ? "formError" : ""
                    }`}>
                    <MultiSelect
                      options={type_of_exercise}
                      state={formValues.selectedTypeOfExercise}
                      setState={(selectedValue) =>
                        setFormValues((prevs) => ({
                          ...prevs,
                          selectedTypeOfExercise: selectedValue,
                        }))
                      }
                      name="Type of Exercises"
                      preventKeyboardOpen={true}
                    />
                  </div>

                  <span className="error-label">
                    {formErrors?.selectedTypeOfExercise || ""}
                  </span>
                </div>

                {formValues.selectedTypeOfExercise?.length > 0 &&
                  formValues.selectedTypeOfExercise?.some(
                    (goal) => goal.value === "other"
                  ) && (
                    <div className="formInputBox twoInputs">
                      <label
                        htmlFor="otherTypeOfExercise"
                        className="formInputLabel">
                        current exercise (Other){" "}
                        <span className="required">*</span>
                      </label>

                      <input
                        type="text"
                        className={`formInput ${
                          formErrors?.otherTypeOfExercise ? "formError" : ""
                        }`}
                        name="otherTypeOfExercise"
                        placeholder="Enter other Type of exercises member currently do"
                        value={formValues.otherTypeOfExercise}
                        onChange={onChangeInput}
                      />

                      <span className="error-label">
                        {formErrors?.otherTypeOfExercise || ""}
                      </span>
                    </div>
                  )}

                {formValues.isInterestedForPT && (
                  <>
                    <div className="formInputBox">
                      <label htmlFor="ptTrailDate" className={`formInputLabel`}>
                        PT Trial Date <span className="required">*</span>
                      </label>

                      <input
                        type="date"
                        placeholder="Enter Member Mobile Number"
                        className={`formInput ${
                          formErrors?.ptTrailDate ? "formError" : ""
                        } ${formValues.ptTrailDate ? "date-has-value" : ""}`}
                        name="ptTrailDate"
                        value={formValues.ptTrailDate}
                        onChange={onChangeInput}
                        min={new Date().toISOString().split("T")[0]}
                      />

                      <span className="error-label">
                        {formErrors?.ptTrailDate || ""}
                      </span>
                    </div>

                    {/* <div className="formInputBox">
                    <label htmlFor="selectedSlot" className={`formInputLabel`}>
                      Slot For PT Trial <span className="required">*</span>
                    </label>

                    <div
                      className={`commonWrapper ${
                        formErrors.selectedSlot && "formError"
                      }`}
                    >
                      <SelectDropdown
                        options={timeSlots}
                        selectedOption={formValues.selectedSlot}
                        setSelectedOption={(selectedValue) =>
                          onChangeDropdown("selectedSlot", selectedValue)
                        }
                        name="Slot"
                        preventKeyboardOpen={true}
                      />
                    </div>

                    <span className="error-label">
                      {formErrors?.selectedSlot || ""}
                    </span>
                  </div> */}

                    <div className="formInputBox">
                      <label
                        htmlFor="selectedPTTrialFocus"
                        className="formInputLabel">
                        consultation focus <span className="required">*</span>
                      </label>

                      <div
                        className={`commonWrapper no-border ${
                          formErrors.selectedPTTrialFocus ? "formError" : ""
                        }`}>
                        <MultiSelect
                          options={pt_trial_focus}
                          state={formValues.selectedPTTrialFocus}
                          setState={(selectedValue) =>
                            setFormValues((prevs) => ({
                              ...prevs,
                              selectedPTTrialFocus: selectedValue,
                            }))
                          }
                          name="Type of Exercises"
                          preventKeyboardOpen={true}
                        />
                      </div>

                      <span className="error-label">
                        {formErrors?.selectedPTTrialFocus || ""}
                      </span>
                    </div>

                    {formValues.selectedPTTrialFocus?.length > 0 &&
                      formValues.selectedPTTrialFocus?.some(
                        (goal) => goal.value === "other"
                      ) && (
                        <div className="formInputBox twoInputs">
                          <label
                            htmlFor="otherPTTrialFocus"
                            className="formInputLabel">
                            consultation focus (Other){" "}
                            <span className="required">*</span>
                          </label>

                          <input
                            type="text"
                            className={`formInput ${
                              formErrors?.otherPTTrialFocus ? "formError" : ""
                            }`}
                            name="otherPTTrialFocus"
                            placeholder="Enter other Type of exercises member currently do"
                            value={formValues.otherPTTrialFocus}
                            onChange={onChangeInput}
                          />

                          <span className="error-label">
                            {formErrors?.otherPTTrialFocus || ""}
                          </span>
                        </div>
                      )}
                  </>
                )}
              </div>

              <div className={`commonWrapper commonSwitchWrapper`}>
                <Form.Check
                  type="switch"
                  name="isWorkedWithPTBefore"
                  className={`${
                    formErrors?.isWorkedWithPTBefore ? "formError" : ""
                  } ${formValues.isWorkedWithPTBefore ? "switch-enabled" : ""}`}
                  label={"worked with a Personal Trainer before"}
                  checked={formValues.isWorkedWithPTBefore}
                  onChange={onChangeInput}
                />

                <Form.Check
                  type="switch"
                  name="isInterestedForPT"
                  className={`${
                    formErrors?.isInterestedForPT ? "formError" : ""
                  } ${formValues.isInterestedForPT ? "switch-enabled" : ""}`}
                  label={"interested in receiving a Free PT consultation"}
                  checked={formValues.isInterestedForPT}
                  onChange={onChangeInput}
                />
              </div>

              <div className="formInputsGrid twoGridSystem">
                {formValues.isWorkedWithPTBefore && (
                  <div className="formInputBox textareaFormInputGrid">
                    <label
                      htmlFor="previousPTExperience"
                      className="formInputLabel">
                      Member Previous PT Experience{" "}
                      <span className="not required">(Optional)</span>
                    </label>

                    <textarea
                      name="previousPTExperience"
                      className={`formInput ${
                        formErrors.previousPTExperience && "formError"
                      }`}
                      placeholder="Enter Member PT Experience"
                      value={formValues.previousPTExperience}
                      onChange={onChangeInput}></textarea>

                    <span className="error-label">
                      {formErrors?.previousPTExperience || ""}
                    </span>
                  </div>
                )}

                {!formValues.isInterestedForPT && (
                  <div className="formInputBox textareaFormInputGrid">
                    <label htmlFor="notPtReason" className="formInputLabel">
                      Member reason of not taking a Free PT Consultation{" "}
                      <span className="required">*</span>
                    </label>

                    <textarea
                      name="notPtReason"
                      className={`formInput ${
                        formErrors.notPtReason && "formError"
                      }`}
                      placeholder="Enter Member reason of not taking a Free PT Consultation"
                      value={formValues.notPtReason}
                      onChange={onChangeInput}></textarea>

                    <span className="error-label">
                      {formErrors?.notPtReason || ""}
                    </span>
                  </div>
                )}

                <div className="formInputBox textareaFormInputGrid">
                  <label
                    htmlFor="userMedicalHistory"
                    className="formInputLabel">
                    Member Medical History(If Any){" "}
                    <span className="not required">(Optional)</span>
                  </label>

                  <textarea
                    name="userMedicalHistory"
                    className={`formInput ${
                      formErrors.userMedicalHistory && "formError"
                    }`}
                    placeholder="Enter Member Medical History If Avaiable"
                    value={formValues.userMedicalHistory}
                    onChange={onChangeInput}></textarea>

                  <span className="error-label">
                    {formErrors?.userMedicalHistory || ""}
                  </span>
                </div>

                <div className="formInputBox textareaFormInputGrid">
                  <label
                    htmlFor="memberPhysicalLimitations"
                    className="formInputLabel">
                    Member Physical Limitations (If Any){" "}
                    <span className="not required">(Optional)</span>
                  </label>

                  <textarea
                    name="memberPhysicalLimitations"
                    className={`formInput ${
                      formErrors.memberPhysicalLimitations && "formError"
                    }`}
                    placeholder="Enter Member Medical History If Avaiable"
                    value={formValues.memberPhysicalLimitations}
                    onChange={onChangeInput}></textarea>

                  <span className="error-label">
                    {formErrors?.memberPhysicalLimitations || ""}
                  </span>
                </div>

                <div className="formInputBox textareaFormInputGrid">
                  <label htmlFor="remarks" className="formInputLabel">
                    remarks <span className="not required">(Optional)</span>
                  </label>

                  <textarea
                    name="remarks"
                    className={`formInput ${formErrors.remarks && "formError"}`}
                    placeholder="Enter Member Medical History If Avaiable"
                    value={formValues.remarks}
                    onChange={onChangeInput}></textarea>

                  <span className="error-label">
                    {formErrors?.remarks || ""}
                  </span>
                </div>
              </div>

              <div className={`formInputsGrid uploadsInputGrids`}>
                <div className="formInputBox formInputUploadBox">
                  <label htmlFor="bcaFile" className="formInputLabel">
                    BCA Report File{" "}
                    <span className="not required">(Optional)</span>
                  </label>

                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.bcaFile ? "formError" : ""
                    }`}>
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.bcaFile ? "file-has-value" : ""
                          }`}
                          id="bcaFile"
                          name="bcaFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="application/pdf"
                          file={formValues.bcaFile}
                          onChange={onChangeInput}
                        />
                      </div>
                      <label className="formInputLabel" htmlFor="bcaFile">
                        BCA Report (PDF Only)
                      </label>
                      {bca_report ? (
                        <span className="previous-file">
                          Previous:{" "}
                          <a href={bca_report}>{extractFileName(bca_report)}</a>
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className="formInputBox formInputUploadBox">
                  <label
                    htmlFor="transformationImageFile"
                    className="formInputLabel">
                    Transformation Images (max 3){" "}
                    <span className="not required">(Optional)</span>
                  </label>

                  <div
                    className={`commonWrapper commonUploadWrapper no-border ${
                      formErrors?.transformationImageFile ? "error" : ""
                    }`}
                    style={{ height: "auto" }}>
                    <div className="icon-upload-btn createIncentiveCategoryForImageUpload">
                      <div className="icon">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="49"
                          height="49"
                          viewBox="0 0 49 49"
                          fill="none">
                          <path
                            d="M35.2188 24.9431C34.3574 24.0828 33.1898 23.5996 31.9725 23.5996C30.7552 23.5996 29.5876 24.0828 28.7262 24.9431L10.7188 42.874C13.3066 42.874 21.1006 42.874 38.2812 42.874C39.8253 42.8683 41.3316 42.3958 42.6023 41.5186C43.873 40.6414 44.8488 39.4004 45.4016 37.9587C45.4016 37.7749 45.5394 37.5759 45.6006 37.3768L45.7844 36.749C45.8349 36.5064 45.8707 36.2609 45.8916 36.014C45.8985 35.9478 45.8985 35.8811 45.8916 35.8149C45.8978 35.7846 45.8978 35.7534 45.8916 35.7231L35.2188 24.9431Z"
                            fill="#A5A5A5"
                          />
                          <path
                            d="M45.9355 13.0463C45.7522 11.1457 44.8653 9.38218 43.4489 8.10171C42.0324 6.82125 40.1886 6.11626 38.2792 6.12508H10.7167C8.8073 6.11626 6.96351 6.82125 5.54706 8.10171C4.13061 9.38218 3.24375 11.1457 3.06046 13.0463C3.04235 13.291 3.04235 13.5367 3.06046 13.7813V35.2188C3.04567 35.484 3.04567 35.7499 3.06046 36.0151C3.09821 36.2728 3.14932 36.5283 3.21359 36.7807C3.7609 38.4437 4.70723 39.9473 5.96984 41.1601C6.36281 41.4953 6.80095 41.7737 7.2714 41.987L26.5192 22.7545C27.2304 22.0415 28.0753 21.4758 29.0054 21.0898C29.9356 20.7038 30.9328 20.5051 31.9398 20.5051C32.9469 20.5051 33.9441 20.7038 34.8742 21.0898C35.8044 21.4758 36.6493 22.0415 37.3605 22.7545L45.9355 31.3295V13.7813C45.9536 13.5367 45.9536 13.291 45.9355 13.0463ZM12.248 18.3751C11.6423 18.3751 11.0502 18.1955 10.5465 17.859C10.0429 17.5224 9.65037 17.0441 9.41858 16.4845C9.18679 15.925 9.12614 15.3092 9.24431 14.7151C9.36247 14.1211 9.65415 13.5754 10.0824 13.1471C10.5107 12.7188 11.0564 12.4271 11.6505 12.3089C12.2446 12.1908 12.8603 12.2514 13.4199 12.4832C13.9795 12.715 14.4578 13.1075 14.7943 13.6111C15.1308 14.1148 15.3105 14.7069 15.3105 15.3126C15.3105 16.1248 14.9878 16.9038 14.4135 17.4781C13.8391 18.0524 13.0602 18.3751 12.248 18.3751Z"
                            fill="#A5A5A5"
                          />
                        </svg>
                      </div>
                      <div className="image">
                        <ImageUploading
                          multiple
                          value={formImages.transformationImageFile}
                          // onChange={(imageList) =>
                          //   onChangeImages(imageList, "transformationImageFile")
                          // }
                          maxNumber={3}
                          dataURLKey="data_url"
                          acceptType={["image/*"]}
                          // acceptType={["jpg", "jpeg", "png", "webp"]}
                        >
                          {({
                            imageList,
                            onImageUpload,
                            onImageRemoveAll,
                            onImageUpdate,
                            onImageRemove,
                            isDragging,
                            dragProps,
                          }) => (
                            <div
                              className="upload__image-wrapper"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                rowGap: "1rem",
                              }}>
                              {formImages.transformationImageFile?.length <
                                3 && (
                                <button
                                  type="button"
                                  style={
                                    isDragging ? { color: "red" } : undefined
                                  }
                                  // onClick={onImageUpload}
                                  onClick={() => {
                                    const input =
                                      document.createElement("input");
                                    input.type = "file";
                                    input.accept = "image/*";
                                    input.capture = "environment";

                                    input.onchange = (e) => {
                                      const file = e.target.files[0];
                                      if (file) {
                                        const reader = new FileReader();
                                        reader.onload = () => {
                                          const dataURL = reader.result;

                                          setFormImages((prevImages) => {
                                            const existingImages =
                                              prevImages.transformationImageFile ||
                                              [];
                                            const updatedImages = [
                                              ...existingImages,
                                              { data_url: dataURL },
                                            ];

                                            onChangeImages(
                                              updatedImages,
                                              "transformationImageFile"
                                            );

                                            return {
                                              ...prevImages,
                                              transformationImageFile:
                                                updatedImages.slice(0, 3),
                                            };
                                          });
                                        };
                                        reader.readAsDataURL(file);
                                      }
                                    };

                                    input.click();
                                  }}
                                  {...dragProps}>
                                  Upload
                                </button>
                              )}
                              &nbsp;
                              {imageList.map((image, index) => (
                                <div key={index} className="image-item">
                                  <img
                                    src={image["data_url"]}
                                    alt=""
                                    width="100"
                                  />
                                  <div className="image-item__btn-wrapper">
                                    <button
                                      type="button"
                                      // onClick={() => onImageUpdate(index)}
                                      onClick={() => {
                                        const input =
                                          document.createElement("input");
                                        input.type = "file";
                                        input.accept = "image/*";
                                        input.capture = "environment";

                                        input.onchange = (e) => {
                                          const file = e.target.files[0];
                                          if (file) {
                                            const reader = new FileReader();
                                            reader.onload = () => {
                                              const dataURL = reader.result;

                                              setFormImages((prevImages) => {
                                                const updatedImages = [
                                                  ...prevImages.transformationImageFile,
                                                ];
                                                updatedImages[index] = {
                                                  data_url: dataURL,
                                                }; // Replace image at the given index

                                                return {
                                                  ...prevImages,
                                                  transformationImageFile:
                                                    updatedImages,
                                                };
                                              });
                                            };
                                            reader.readAsDataURL(file);
                                          }
                                        };

                                        input.click();
                                      }}
                                      // onClick={() => {
                                      //   const input =
                                      //     document.createElement("input");
                                      //   input.type = "file";
                                      //   input.accept = "image/*";

                                      //   input.onchange = (e) => {
                                      //     const file = e.target.files[0];
                                      //     if (file) {
                                      //       const reader = new FileReader();
                                      //       reader.onload = () => {
                                      //         const dataURL = reader.result;
                                      //         setFormImages((prevImages) => {
                                      //           const updatedImages = [
                                      //             ...prevImages.transformationImageFile,
                                      //           ];
                                      //           updatedImages[index] = {
                                      //             data_url: dataURL,
                                      //           };
                                      //           onChangeImages(
                                      //             updatedImages,
                                      //             "transformationImageFile"
                                      //           );
                                      //           return {
                                      //             ...prevImages,
                                      //             transformationImageFile:
                                      //               updatedImages,
                                      //           };
                                      //         });
                                      //       };
                                      //       reader.readAsDataURL(file);
                                      //     }
                                      //   };

                                      //   input.click();
                                      // }}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-cloud-plus"
                                        viewBox="0 0 16 16">
                                        <path
                                          fillRule="evenodd"
                                          d="M8 5.5a.5.5 0 0 1 .5.5v1.5H10a.5.5 0 0 1 0 1H8.5V10a.5.5 0 0 1-1 0V8.5H6a.5.5 0 0 1 0-1h1.5V6a.5.5 0 0 1 .5-.5z"
                                        />
                                        <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383zm.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
                                      </svg>
                                    </button>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        onImageRemove(index);
                                        handleImageRemove(index);
                                      }}
                                      // onClick={() => onImageRemove(index)}
                                    >
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="currentColor"
                                        className="bi bi-x"
                                        viewBox="0 0 16 16">
                                        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              ))}
                              {/* </> */}
                              {/* )} */}
                            </div>
                          )}
                        </ImageUploading>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <>
                {/* <div className="full-width flexStart">
                <div className={`flex-col-center-start multi-file`}>
                  <label htmlFor="bcaFile" className="formInputLabel">
                    BCA Report File <span className="required">*</span>
                  </label>

                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.bcaFile ? "formError" : ""
                    }`}
                  >
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.bcaFile ? "file-has-value" : ""
                          }`}
                          id="bcaFile"
                          name="bcaFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="application/pdf"
                          file={formValues.bcaFile}
                          onChange={onChangeInput}
                        />
                      </div>
                      <label
                        // className="custom-file-label"
                        className="formInputLabel"
                        htmlFor="bcaFile"
                      >
                        BCA Report (PDF Only)
                      </label>
                      {isEdit && rowData?.bca_report ? (
                        <span className="previous-file">
                          Previous:{" "}
                          <a href={rowData.bca_report}>
                            {extractFileName(rowData.bca_report)}
                          </a>
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>

                <div className={`full-width flex-col-center-start multi-file`}>
                  <label
                    htmlFor="transformationImageFile"
                    className="formInputLabel"
                  >
                    Transformation Image
                  </label>

                  <div
                    className={`input-group file-upload-input ${
                      formErrors?.transformationImageFile ? "formError" : ""
                    }`}
                  >
                    <div className="custom-file">
                      <div className="choosefileBtn">
                        <input
                          type="file"
                          className={`custom-file-input ${
                            formValues.transformationImageFile?.length
                              ? "file-has-value"
                              : ""
                          }`}
                          id="transformationImageFile"
                          name="transformationImageFile"
                          aria-describedby="inputGroupFileAddon01"
                          accept="image/*"
                          multiple
                          onChange={onChangeInput}
                        />
                      </div>
                      <label
                        className="formInputLabel"
                        htmlFor="transformationImageFile"
                      >
                        Transformation Image (Image Only)
                      </label>
                      {isEdit && rowData?.prog_pics?.length > 0 ? (
                        <div className="flexCol">
                          {rowData?.prog_pics?.map((tImg, index) => (
                            <span className="previous-file" key={index}>
                              Previous:{" "}
                              <a href={tImg}>{extractFileName(tImg)}</a>
                            </span>
                          ))}{" "}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              </div> */}
              </>

              <div className="formButtons">
                <Button
                  type="button"
                  className="saveBtn"
                  variant="danger"
                  onClick={onSumitForm}>
                  {postPutLoading ? <Loader /> : isEdit ? "Update" : "Submit"}
                </Button>
              </div>
            </>
          )}
        </form>
      )}
    </div>
  );
};

export default TMEForm;
